export const sanctionsFallbackMessage = 'Виявлено санкції щодо страхувальника. Оформлення поліса неможливе.';

export const sanctionsStatusMessage = {
  sanctioned: 'Даного клієнта знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка',
  possible_match: 'Даного клієнта вірогідно знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка',
  no_data: 'Немає даних',
};
